import { render, staticRenderFns } from "./myheader.vue?vue&type=template&id=09b12400&"
import script from "./myheader.vue?vue&type=script&lang=js&"
export * from "./myheader.vue?vue&type=script&lang=js&"
import style0 from "./myheader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports